import React from 'react';
import { Col, Grid, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { RootState } from '../store/store';
import { ProfileCreationFormProvider } from '../components/SellerProfileCreation/ProfileCreationFormProvider';
import { setCurrentStep } from '../store/slices/sellerProfileSlice';

import ProfileReview from '../components/SellerProfileCreation/steps/ProfileReview/ProfileReview';
// @ts-ignore
import './SellerProfileCreation.css';
import BranchesAndWarehouses from '../components/SellerProfileCreation/steps/BranchesAndWarehouses/BranchesAndWarehouses';
import Catalogue from '../components/SellerProfileCreation/steps/Catalogue/Catalogue';
import ProfileCreationNavbar from '../components/SellerProfileCreation/ProfileCreationNavbar';
import ProfileCreationHeader from '../components/SellerProfileCreation/ProfileCreationHeader';
import ProfileCreationStepper from '../components/SellerProfileCreation/ProfileCreationStepper';
import CompanyInfo from '../components/SellerProfileCreation/steps/CompanyInfo/CompanyInfo';
import Category from '../components/SellerProfileCreation/steps/Category/Category';
import AwardsAndCertificates from '../components/SellerProfileCreation/steps/AwardsAndCertificates/AwardsAndCertificates';

const { useBreakpoint } = Grid;

const SellerProfileCreation: React.FC = () => {
  const { currentStep } = useSelector((state: RootState) => state.sellerProfile);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const isEditMode = searchParams.get('mode') === 'edit';

  React.useEffect(() => {
    if (isEditMode) {
      dispatch(setCurrentStep(5));
    } else {
      dispatch(setCurrentStep(0));
    }
  }, [isEditMode, dispatch]);

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const isReviewStep = currentStep === 5;

  const components = [
    <CompanyInfo key={0} />,
    <Catalogue key={1} />,
    <Category key={2} />,
    <AwardsAndCertificates key={3} />,
    <BranchesAndWarehouses key={4} />,
    <ProfileReview key={5} />,
  ];

  return (
    <ProfileCreationFormProvider>
      <Row justify="center" data-testid="profile-creation-page" className="w-full">
        <Col span={24} className="space-y-4">

          <ProfileCreationHeader />

          <div
            className="bg-white dark:bg-dark-surface-primary rounded-[8px] border border-gray-200 dark:border-dark-input-border overflow-hidden"
            data-testid="profile-creation-form-card"
          >
            {!isReviewStep && isMobile && (
              <div className="p-4 border-b border-[#e5e7eb] dark:border-dark-input-border">
                <ProfileCreationStepper />
              </div>
            )}
            <Row wrap={false} align="top" className="min-h-[500px]">
              {!isReviewStep && !isMobile && (
                <Col
                  flex="0 0 25%"
                  className="border-e border-[#e5e7eb] dark:border-dark-input-border p-6"
                  data-testid="profile-creation-stepper-col"
                >
                  <ProfileCreationStepper />
                </Col>
              )}

              <Col
                flex={1}
                className="hidden-scrollbar overflow-y-auto p-6 px-16"
                data-testid="profile-creation-content-col"
              >
                {components[currentStep]}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </ProfileCreationFormProvider>
  );
};

export default SellerProfileCreation;
